import * as THREE from 'three';

import grid_vShader from 'raw-loader!./grid_vShader.vert';
import grid_fShader from 'raw-loader!./grid_fShader.frag';

/**
 * Creates a Grid mesh. Just add the grid.mesh to your scene.
 * 2020 - Benjamin Ingold - OKENITE
 * 
 * @property {THREE.mesh} mesh grid mesh object
 */
export default class Grid {
    /**
     * 
     * @param {float} gridSize Overall size of the grid ine the scene (width) in centimeter
     * @param {*} cellSize  Size of a grid cell in centimeter
     * @param {*} thickness Line Thickness
     * @param {*} color Line Color
     */
    constructor(gridSize, cellSize, thickness, color, opacity) {

        this.gridSize = gridSize;
        this.cellSize = cellSize;
        this.thickness = thickness;
        this.color = color;
        this.opacity = opacity;

        this.mesh = null;
        this.vshader = null;
        this.fshader = null;
        this.uniforms = null;
        
        this.init();
    }

    init()
    {
        var geometry = new THREE.PlaneGeometry( this.gridSize, this.gridSize, 1, 1 );

        this.uniforms = {
            "cellSize" : { value : this.cellSize },
            "thickness" : { value : this.thickness },
            "color": { value: this.color },
            "opacity": { value: this.opacity },

        }; 
        var shaderMaterial = new THREE.ShaderMaterial( {

            uniforms: this.uniforms,
            vertexShader: grid_vShader,
            fragmentShader: grid_fShader,
            blending: THREE.NormalBlending,
            depthTest: true,
            transparent: true,
            side: THREE.FrontSide

        } );

        this.mesh = new THREE.Mesh( geometry, shaderMaterial );
        this.mesh.rotation.x = - Math.PI / 2;

        return this.mesh;
    }


}